import { render, staticRenderFns } from "./PaymentDisplayDialog.vue?vue&type=template&id=63bb0904"
import script from "./PaymentDisplayDialog.vue?vue&type=script&lang=js"
export * from "./PaymentDisplayDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports